import { combineReducers } from 'redux';
import accounts from './accounts';
import accountsParents from './accounts-parents';

export const parentPublisherSettingsReducers = combineReducers({ accounts, accountsParents });
